import React from 'react';
import { reportActions } from 'actions/ReportActions';
import { reportStore } from 'stores/ReportStore';

export class WindDataWarningPopup extends React.Component {
  constructor(props) {
    super(props);
    reportStore.listen(this.storeUpdated.bind(this));
    this.state = reportStore.getState();
  }

  storeUpdated() {
    this.setState(reportStore.getState());
  }

  componentDidUpdate() {
    this.state = this.props;
  }

  closeWindDataWarningPopup() {
    reportActions.closeWindDataWarningPopup();
  }

  render() {
    return (
      <div className={`details-popup-wrapper ${this.state.loadWindDataWarningPopupVisible ? '' : 'hidden'}`}>
        <div id={'detailsPopup'} className={'details-popup'}>
          <div className='popup-header blue darken-3'>
            <span>ASCE HAZARD TOOL</span>
            <span className='details-popup-close-icon' onClick={this.closeWindDataWarningPopup}></span>
          </div>
          <div className='padding popup-body'>
            7-22 Wind Load data for Puerto Rico and U.S. Virgin Islands is temporarily unavailable. Thank you for your
            patience as we work to resolve this issue.
          </div>
          <div className={'fill_wide padding__long white popup-ok-button'}>
            <a
              className={'waves-effect waves-light btn-large blue darken-4 fill__wide '}
              onClick={this.closeWindDataWarningPopup}
            >
              OK
            </a>
          </div>
        </div>
      </div>
    );
  }
}
